export const timeToSeconds = time => {
  if (!time) return 0;

  const parts = String(time)
    .split(':')
    .map(Number);

  if (parts.some(part => Number.isNaN(part))) return 0;

  if (parts.length === 3) {
    const [hours, minutes, seconds] = parts;
    return hours * 3600 + minutes * 60 + seconds;
  }

  if (parts.length === 2) {
    const [minutes, seconds] = parts;
    return minutes * 60 + seconds;
  }

  return parts[0] || 0;
};

export const getActiveChapter = (chapters, currentTime) => {
  if (!chapters?.length) return null;
  const seconds = timeToSeconds(currentTime);

  for (let i = 0; i < chapters.length; i++) {
    const section = chapters[i];
    const start = timeToSeconds(section.start);
    const end = timeToSeconds(section.end);
    const isLast = i === chapters.length - 1;

    if (seconds >= start && (seconds < end || (isLast && seconds <= end))) {
      return section;
    }
  }

  return null;
};
